import { render, staticRenderFns } from "./cardDetail.vue?vue&type=template&id=5da09316&scoped=true"
import script from "./cardDetail.vue?vue&type=script&lang=js"
export * from "./cardDetail.vue?vue&type=script&lang=js"
import style0 from "./cardDetail.vue?vue&type=style&index=0&id=5da09316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da09316",
  null
  
)

export default component.exports